import PrDataInput2Component from './pr-data-input-2';

export default PrDataInput2Component;
